import { configureStore } from '@reduxjs/toolkit';
import liveChatReducer from '@/redux/slices/liveChatSlice';
import userBonusesReducer from '@/redux/slices/userBonusesSlice';
import userReducer from '@/redux/slices/userSlice';

export const store = () => {
  return configureStore({
    reducer: {
      user: userReducer,
      userBonuses: userBonusesReducer,
      liveChat: liveChatReducer,
    },
  });
};

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppStore = ReturnType<typeof store>;
export type RootState = ReturnType<ReturnType<typeof store>['getState']>;
export type AppDispatch = ReturnType<typeof store>['dispatch'];
